
const isIE = () => 
/Trident\/|MSIE/.test(window.navigator.userAgent);

export default isIE;